import { ROBINHOOD_CHAIN } from '@fukemon/shared';
import { useAccount, useConnect, useDisconnect, useSwitchChain } from 'wagmi';
import { Icon } from './Icon';

function shortAddress(address: string) {
  return `${address.slice(0, 6)}…${address.slice(-4)}`;
}

export function WalletButton() {
  const { address, isConnected, chainId } = useAccount();
  const { connectors, connect, isPending } = useConnect();
  const { disconnect } = useDisconnect();
  const { switchChain, isPending: switching } = useSwitchChain();

  if (isConnected && chainId !== ROBINHOOD_CHAIN.id) {
    return (
      <button
        className="wallet-button wallet-button--wrong"
        onClick={() => switchChain({ chainId: ROBINHOOD_CHAIN.id })}
        disabled={switching}
      >
        <Icon name="wallet" size={16} />
        {switching ? 'SWITCHING…' : 'SWITCH TO 4663'}
      </button>
    );
  }

  if (isConnected && address) {
    return (
      <button
        className="wallet-button wallet-button--connected"
        onClick={() => disconnect()}
        title="Disconnect wallet"
      >
        <span className="status-dot" />
        {shortAddress(address)}
      </button>
    );
  }

  const connector = connectors.find((item) => item.id === 'walletConnect') ?? connectors[0];
  return (
    <button
      className="wallet-button"
      onClick={() => connector && connect({ connector })}
      disabled={!connector || isPending}
    >
      <Icon name="wallet" size={16} />
      {isPending ? 'OPENING WALLET…' : 'CONNECT WALLET'}
    </button>
  );
}

